/**
 * announcement-broadcast.ts
 * Copyright (c) 2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

import { IncomingMessage } from "../general/incoming-message";
import { MessageTag } from "../message-tag";

export class AnnouncementBroadcast extends IncomingMessage
{
    public tag : MessageTag = MessageTag.BCST_ANNOUNCEMENT;

    public message : string;
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/admin/announcement-broadcast.ts